import React, { useRef, useState } from 'react';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import { API_Root } from "../globalState";
import axios from 'axios'
import './SuperAdmin.css';

export const SuperAdmin = () => {
   const [placesearch, setPlaceSearch] = useState('');
   const [source, setSource] = useState();
   const [places, setPlaces] = useState();
   const [userEmail, setUserEmail] = useState('');
   const [searching, setSearching] = useState(false);
   const [saving, setSaving] = useState(false);
   const toast = useRef(null);

   const doPlaceSearch = () => {
      const query = (placesearch || '').trim();
      if (!query) {
         return;
      }

      setSearching(true);
      var apiUrl = `${API_Root}api/dealership/getDealerPlaces?query=${encodeURIComponent(query)}`;
      axios.get(apiUrl).then((values) => {
         console.log('place search', values.data);
         setPlaces(values.data || []);
      }).catch(() => {
         toast.current?.show({ severity: 'error', summary: 'Search failed', detail: 'Could not search dealerships.', life: 4000 });
      }).finally(() => {
         setSearching(false);
      });
   }

   const saveUser = () => {
      if (!canAdd) {
         return;
      }

      var apiUrl = `${API_Root}api/user/AddAdminUser`;
      var dto = {
         userEmail: userEmail,
         dealership: source
      };

      setSaving(true);
      axios.post(apiUrl, dto).then((values) => {
         console.log('get dealership', values.data);
         if (values.data === true) {
            toast.current.show({ severity: 'success', summary: 'Admin added', detail: 'Dealer admin was created.', life: 3000 });
            setUserEmail('');
         }
         else {
            toast.current.show({ severity: 'error', summary: 'Could not add admin', detail: 'The admin user could not be created.', life: 3000 });
         }
      }).catch(() => {
         toast.current.show({ severity: 'error', summary: 'Could not add admin', detail: 'The admin user could not be created.', life: 4000 });
      }).finally(() => {
         setSaving(false);
      });
   }

   const handleSearchKeyDown = (event) => {
      if (event.key === 'Enter') {
         doPlaceSearch();
      }
   }

   const validateEmail = (e) => {
      return String(e)
         .toLowerCase()
         .match(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
         );
   };

   const selectSource = (p) => {
      setSource(p);
      setPlaceSearch('');
      setPlaces(undefined);
   }

   const clearSource = () => {
      setSource(undefined);
   }

   const emailValid = userEmail && validateEmail(userEmail);
   const canAdd = !!source && emailValid;
   const emailClass = (userEmail && !emailValid) ? 'p-invalid w-full' : 'w-full';

   const searchResults = () => {
      if (searching) {
         return (
            <div className="system-admin-empty">
               <i className="pi pi-spin pi-spinner"></i>
               Searching dealerships…
            </div>
         );
      }

      if (places === undefined) {
         return (
            <div className="system-admin-empty">
               <i className="pi pi-search"></i>
               Search by dealership name or address
            </div>
         );
      }

      if (places.length === 0) {
         return (
            <div className="system-admin-empty">
               <i className="pi pi-map-marker"></i>
               No dealerships matched that search
            </div>
         );
      }

      return (
         <div className="system-admin-places">
            {places.map((p, i) => (
               <button type="button" className="system-admin-place" key={i} onClick={() => selectSource(p)}>
                  <div className="system-admin-place-mark">
                     <i className="pi pi-building"></i>
                  </div>
                  <div>
                     <div className="system-admin-place-name">{p.name || 'Private Address'}</div>
                     <div className="system-admin-place-addr">{p.formatted_address}</div>
                  </div>
               </button>
            ))}
         </div>
      );
   }

   return (
      <div className="system-admin-page">
         <Toast ref={toast} />
         <div className="system-admin-header">
            <h2 className="system-admin-title">System admin</h2>
            <p className="system-admin-meta">Add a dealer admin to a dealership</p>
         </div>
         <div className="system-admin-layout">
            <section className="system-admin-card">
               <div className="system-admin-card-head">
                  <div className="system-admin-card-icon"><i className="pi pi-building"></i></div>
                  <div>
                     <h3>Find dealership</h3>
                     <p>Search Google Places, then pick the location</p>
                  </div>
               </div>
               <div className="system-admin-search">
                  <InputText
                     placeholder="Dealership name or address"
                     value={placesearch}
                     onChange={(e) => setPlaceSearch(e.target.value)}
                     onKeyDown={handleSearchKeyDown} />
                  <Button
                     icon="pi pi-search"
                     label="Search"
                     onClick={() => doPlaceSearch()}
                     disabled={!placesearch?.trim() || searching}
                     loading={searching} />
               </div>
               {searchResults()}
            </section>
            <section className="system-admin-card">
               <div className="system-admin-card-head">
                  <div className="system-admin-card-icon"><i className="pi pi-user-plus"></i></div>
                  <div>
                     <h3>Assign admin</h3>
                     <p>Create a dealer admin for the selected location</p>
                  </div>
               </div>
               {source ? (
                  <div className="system-admin-selected">
                     <div className="system-admin-selected-top">
                        <div>
                           <p className="system-admin-selected-name">{source.name || 'Private Address'}</p>
                           <p className="system-admin-selected-addr">{source.formatted_address}</p>
                        </div>
                        <Button label="Change" link onClick={clearSource} />
                     </div>
                  </div>
               ) : (
                  <div className="system-admin-empty">
                     <i className="pi pi-building"></i>
                     Select a dealership from the search results
                  </div>
               )}
               <div className="system-admin-field">
                  <label htmlFor="adminEmail">Admin email</label>
                  <InputText
                     id="adminEmail"
                     placeholder="name@example.com"
                     value={userEmail}
                     onChange={(e) => setUserEmail(e.target.value)}
                     className={emailClass}
                     disabled={!source} />
                  <p className="system-admin-hint">They will be added as a dealer admin for this location</p>
               </div>
               <div className="system-admin-actions">
                  <Button
                     label="Add dealer admin"
                     icon="pi pi-user-plus"
                     onClick={() => saveUser()}
                     disabled={!canAdd}
                     loading={saving} />
               </div>
            </section>
         </div>
      </div>
   );
};
